import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { name, BackgroundScrubSymbol } from '../symbols'
import {
	EditorFeatureConfigSymbol,
	IPageWillMountHandler,
	IPageWillUnmountHandler,
	LayoutDoneServiceSymbol,
	ILayoutDoneService,
} from '@wix/thunderbolt-symbols'
import type { IBackgroundScrub, BackgroundScrubEditorConfig } from '../types'

const editorBackgroundScrubFactory = (
	editorConfig: BackgroundScrubEditorConfig,
	backgroundScrub: IBackgroundScrub,
	layoutDoneService: ILayoutDoneService
): IPageWillMountHandler & IPageWillUnmountHandler => {
	return {
		name: 'backgroundScrub',
		pageWillMount() {
			if (editorConfig.shouldScrub) {
				backgroundScrub.destroy(false)
				layoutDoneService.registerToRenderDone(
					() => {
						backgroundScrub.init()
					},
					{ once: true }
				)
			} else {
				backgroundScrub.destroy(true)
			}
		},
		pageWillUnmount() {
			backgroundScrub.destroy(true)
		},
	}
}

export const BackgroundScrub = withDependencies(
	[named(EditorFeatureConfigSymbol, name), BackgroundScrubSymbol, LayoutDoneServiceSymbol],
	editorBackgroundScrubFactory
)
